import { DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';
import { Payload } from '../payload.js';
import { PayloadType } from '../payload-type.js';
import { MapUtils } from '../../../../utility/map-utils.js';

export class SeatSelectionRequestPayload extends Payload {
  static readonly TYPE_ID = 'b5cb434ed9d74abb80e6dc6a0c9e66cb';

  private constructor(
    public readonly target: string,
    public readonly seatId: number,
  ) {
    super();
  }

  get $typeId(): string {
    return SeatSelectionRequestPayload.TYPE_ID;
  }

  get type(): PayloadType {
    return PayloadType.SeatSelectionRequest;
  }

  static create(args: {
    target: string;
    seatId: number;
  }): SeatSelectionRequestPayload {
    return new SeatSelectionRequestPayload(args.target, args.seatId);
  }

  static fromMap(context: SerializationContext, map: SerializedData): SeatSelectionRequestPayload {
    return SeatSelectionRequestPayload.create({
      target: MapUtils.getString(map, 'target'),
      seatId: MapUtils.getInteger(map, 'seatId'),
    });
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      'target': this.target,
      'seatId': this.seatId,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    target = this.target,
    seatId = this.seatId,
  }: {
    target?: string;
    seatId?: number;
  } = {}): this {
    return SeatSelectionRequestPayload.create({ target, seatId }) as this;
  }

  isSame(other: SeatSelectionRequestPayload): boolean {
    return this === other || (
      this.target === other.target &&
      this.seatId === other.seatId
    );
  }
}

export class SeatSelectionRequestPayloadBuilder extends DataModelBuilder<SeatSelectionRequestPayload> {
  build(context: SerializationContext, map: SerializedData): SeatSelectionRequestPayload {
    return SeatSelectionRequestPayload.fromMap(context, map);
  }
}
